/**
 * ZAVO V9.5 — Unified pagination runtime
 * Uses the ACTUAL rendered ZERO Product Carousel V7 dots as the visual reference.
 * Category Navigator and Sold Archive are styled from the computed reference,
 * so editor customisations on the Product Carousel are mirrored automatically.
 */
(() => {
  if (window.__zavoUnifiedPaginationV95) return;
  window.__zavoUnifiedPaginationV95 = true;

  let queued = false;

  const setImportant = (el, prop, value) => {
    if (!el || value == null || value === '') return;
    el.style.setProperty(prop, value, 'important');
  };

  const readDot = (el) => {
    if (!el) return null;
    const s = getComputedStyle(el);
    return {
      width: s.width,
      height: s.height,
      minWidth: s.minWidth,
      minHeight: s.minHeight,
      maxWidth: s.maxWidth,
      maxHeight: s.maxHeight,
      flexBasis: s.flexBasis,
      border: s.border,
      borderRadius: s.borderRadius,
      backgroundColor: s.backgroundColor,
      opacity: s.opacity,
      transform: s.transform,
      boxShadow: s.boxShadow,
      padding: s.padding,
      margin: s.margin,
      aspectRatio: s.aspectRatio,
      transition: s.transition
    };
  };

  const fallbackInactive = {
    width: '7px', height: '7px', minWidth: '0px', minHeight: '0px', maxWidth: '7px', maxHeight: '7px',
    flexBasis: '7px', border: '0px none rgba(0, 0, 0, 0)', borderRadius: '50%',
    backgroundColor: 'rgba(12, 12, 12, 0.28)', opacity: '1', transform: 'none', boxShadow: 'none',
    padding: '0px', margin: '0px', aspectRatio: '1 / 1', transition: 'transform 0.25s ease, background 0.25s ease, opacity 0.25s ease'
  };
  const fallbackActive = {...fallbackInactive, backgroundColor: 'rgb(152, 118, 42)', transform: 'matrix(1.3, 0, 0, 1.3, 0, 0)'};

  const applyDot = (dot, style) => {
    setImportant(dot, 'appearance', 'none');
    setImportant(dot, '-webkit-appearance', 'none');
    setImportant(dot, 'display', 'block');
    setImportant(dot, 'width', style.width);
    setImportant(dot, 'height', style.height);
    setImportant(dot, 'min-width', style.minWidth);
    setImportant(dot, 'min-height', style.minHeight);
    setImportant(dot, 'max-width', style.maxWidth);
    setImportant(dot, 'max-height', style.maxHeight);
    setImportant(dot, 'flex-basis', style.flexBasis || style.width);
    setImportant(dot, 'flex-grow', '0');
    setImportant(dot, 'flex-shrink', '0');
    setImportant(dot, 'border', style.border);
    setImportant(dot, 'border-radius', style.borderRadius);
    setImportant(dot, 'background-color', style.backgroundColor);
    setImportant(dot, 'opacity', style.opacity);
    setImportant(dot, 'transform', style.transform);
    setImportant(dot, 'box-shadow', style.boxShadow);
    setImportant(dot, 'padding', style.padding || '0px');
    setImportant(dot, 'margin', style.margin || '0px');
    setImportant(dot, 'aspect-ratio', style.aspectRatio || '1 / 1');
    setImportant(dot, 'line-height', '0');
    setImportant(dot, 'font-size', '0');
    setImportant(dot, 'transition', style.transition);
  };

  const applyWrap = (wrap, referenceWrap) => {
    if (!wrap) return;
    const s = referenceWrap ? getComputedStyle(referenceWrap) : null;
    setImportant(wrap, 'align-items', s?.alignItems || 'center');
    setImportant(wrap, 'justify-content', s?.justifyContent || 'center');
    setImportant(wrap, 'gap', s?.gap || '7px');
    setImportant(wrap, 'margin-top', s?.marginTop || '24px');
    setImportant(wrap, 'min-height', s?.minHeight || '12px');
  };

  const sync = () => {
    queued = false;

    const refWrap = document.querySelector('.zpc7-dots');
    const refDots = Array.from(document.querySelectorAll('.zpc7-dot'));
    const refActive = refDots.find((dot) => dot.classList.contains('is-active'));
    const refInactive = refDots.find((dot) => !dot.classList.contains('is-active'));

    const inactiveStyle = readDot(refInactive || refDots[0]) || fallbackInactive;
    let activeStyle = readDot(refActive);
    if (!activeStyle) {
      activeStyle = {...inactiveStyle, ...fallbackActive};
    }

    document.querySelectorAll('.zcn__dots, .zsa__dots').forEach((wrap) => applyWrap(wrap, refWrap));
    document.querySelectorAll('.zcn__dot, .zsa__dot').forEach((dot) => {
      applyDot(dot, dot.classList.contains('is-active') ? activeStyle : inactiveStyle);
    });
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  window.addEventListener('resize', schedule, {passive:true});
})();
